export interface ISnackMsg {
    msg: string,
    type: SnackTypeMsg,
    innerHtml?: string,
    callback?: any
    callbackTitle?: string,
}

export enum SnackTypeMsg {
    Success = 'success',
    Error = 'error',
    Info = 'info',
    Warning = 'warning'
}

export enum SnackVerticalPosition {
    Bottom = 'bottom',
    Top = 'top'
}

export enum SnackHorizontalPosition {
    Start = 'start',
    Center = 'center',
    End = 'end',
    Left = 'left',
    Right = 'right'
}
